import { AnyAction } from "redux";
import { loadData } from "../../../connection";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

interface ActionDefault<T> {
  type: string;
  payload: T;
}

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataRequest = () => {
  return {
    type: FETCH_DATA_REQUEST,
  };
};

const fetchDataSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_SUCCESS,
    payload: data,
  };
};

const fetchDataFailure = (error: any) => {
  return {
    type: FETCH_DATA_FAILURE,
    payload: error,
  };
};

export const getConnection = (
  filter: Query,
  page: number = 1,
  limit: number = 15
) => {
  return async (dispatch: Dispatch<AnyAction>, getState: any) => {
    dispatch(fetchDataRequest());
    try {
      const response = await loadData(
        "connection_request",
        filter,
        page,
        limit
      );
      dispatch(fetchDataSuccess(response));
    } catch (error: any) {
      dispatch(fetchDataFailure(error.message));
    }
  };
};
